
//Instalados
import React,{useRef} from "react";
import { Form } from '@unform/web';

import axsLogo from "../Images/AxsLogo.svg";
import setaVoltar from "../Images/SetaVoltar.svg";

//Próprios
import "../Login/css/MasterLogin.css";
import "../Login/css/MasterLoginMobile.css";
import { Input } from '../Inputs/Input';

export default function TelaLoginNew() {
  const useFormRef = useRef(null);

  const handleSubmit = async (data) => {}

  const handleBack = (() => {
    window.location.href = "/arp/login/"
  });

return (
  <>    
    <div className="GridLogin">
          <div className="DivMotivation">
          <div onClick={handleBack}><img  className="imgSeta" src={setaVoltar} alt='' /></div>
          
            <div className="DivTextMotivation">
            <div className="Conic"><span className="Aspas"></span></div>
              O segredo do sucesso é a constância do propósito.
              <div className="DivAutorMotivation">
                  Benjamin Disraeli 
                </div>
              </div>
              <br/><br/><br/>
          </div>
            <div className="DivInputs">
            <img className="imgLog" src={axsLogo} alt='' />
              <div className="DivTextInputs">Bem vindo, representante!</div>
              <div className="DivSecondTextInputs">
                  Pronto para vender muito? 🚀
              </div>
              <br/><br/><br/>
              <div className="Inputs">
              <Form ref={useFormRef}
                onSubmit={handleSubmit}
              >
                <Input
                  type="text"
                  name="user"
                  placeholder="Nome"
                  className="form-control"
                  style={{ width: '100%', backgroundColor: '#f5f5f5', border: 'none' }} />
                <Input
                  type="text"
                  name="user"
                  placeholder="Email"
                  className="form-control"
                  style={{ width: '100%', backgroundColor: '#f5f5f5', border: 'none' }} />
                 <Input
                  type="text"
                  name="user"
                  placeholder="CPF ou CNPJ"
                  className="form-control"
                  style={{ width: '100%', backgroundColor: '#f5f5f5', border: 'none' }} />
                  <button type="submit" className="btnPurple">Começar</button>
               </Form>
                <br/>
              </div>
            </div>
    </div>
  </>
    );
  }
